// extracted by mini-css-extract-plugin
var _1 = "CellResizeControl_control__2a650";
var _2 = "CellResizeControl_root__4dbe2";
export { _1 as "control", _2 as "root" }
